// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {CSSProperties, useCallback, useEffect,
    useRef, useState} from 'react';
import {useHistory} from 'react-router-dom';
import cn from 'classnames';
import {use_theme} from '../../../../hola/pub/settings_ctx';
import {NAVBAR_SLOTS, use_navbar} from './use_navbar';
import Icon_menu from '../../img/icons/24/menu.svg';
import Icon_close from '../../img/icons/24/close.svg';
import Icon_dashboard from '../../img/icons/24/dashboard.svg';
import Icon_chevron_down from '../../img/icons/24/chevron_down_small.svg';
import {use_app_context} from '../../../../toolip/pub/lib/app_context';
import {use_login} from './use_login';
import {Products_menu} from './products';
import {Locations_menu} from './locations';
import {Button} from '../../lib/button';
import {Logo} from '../../lib/logo';
import styles from './mobile_nav.module.less';

interface i_links_group_props {
    title: string | JSX.Element;
    content?: (on_toggle?: ()=>void)=>React.ReactNode;
    level?: number;
    cls?: string;
    to?: string;
}
const Links_group = (props: i_links_group_props)=>{
    const {title, content = null, cls, to} = props;
    const {theme} = use_theme({def: 'oculus'});
    const history = useHistory();
    const [expanded, set_expanded] = useState(false);
    const [style, set_style] = useState<CSSProperties>({});
    const content_ref = useRef<HTMLDivElement>();
    const calc_style = useCallback(()=>{
        if (!content_ref.current)
            return;
        const b = content_ref.current.getBoundingClientRect();
        set_style({'--expander_height': `${b.height}px`} as CSSProperties);
    }, [content_ref.current]);
    useEffect(()=>{
        calc_style();
        window.addEventListener('resize', calc_style);
        return ()=>{
            window.removeEventListener('resize', calc_style);
        };
    }, [calc_style]);
    const group_cls = cn(styles.links_group, cls, expanded && styles.expanded);
    return <div className={group_cls} style={style}>
      <p className={cn(theme.p16, theme.bold, styles.title)}
        onClick={()=>{
          if (to)
            history.push(to);
          else
            set_expanded(v=>!v);
        }}>
        {title}
        {!to && <Icon_chevron_down className={styles.title_icon}/>}
      </p>
      {!to && <div className={styles.content}
        ref={content_ref}>{content(calc_style)}</div>}
    </div>;
};

const Login_menu = ({on_login, pos})=>{
    return <div className={cn(styles.login_menu, styles[pos])}>
      <Button color={pos=='top' ? 'tertiary' : 'secondary'} size="s"
        caption="Log in" on_click={on_login} clickid="mobile_nav_login"/>
      <Button size="s" caption="Get started" to="/pricing"
        clickid="mobile_nav_start"/>
    </div>;
};

const Burger = ({on_toggle, pos})=>{
    return <div className={cn(styles.burger, styles[pos])} onClick={on_toggle}>
      <Icon_menu className={styles.icon_menu}/>
      <Icon_close className={styles.icon_close}/>
    </div>;
};

const Dashboard_btn = ({pos, to})=>{
    return <Button color="secondary" cls={cn(styles.dashboard, styles[pos])}
      size="s" caption={<span>Dashboard</span>} to={to}
      clickid="mobile_nav_dashboard" icon_left={<Icon_dashboard/>}
    />;
};

type t_mobile_nav_props = ReturnType<typeof use_navbar>;

const Oculus_mobile_nav = (props: t_mobile_nav_props)=>{
    const {has_user, toggle, cp_link, cp_after_login,
        headlogo, burger_pos} = props;
    const on_toggle = ()=>{ toggle(); };
    const {is_client, user} = use_app_context();
    const {on_login} = use_login(cp_after_login, cp_link);
    const show_top_menu = !headlogo;
    return <>
      <div className={styles.logo_container}
        data-slot={NAVBAR_SLOTS.mobile_left}>
        {burger_pos=='left' && <Burger on_toggle={on_toggle}
          pos={burger_pos}/>}
        <Logo clickid="nav_mobile_logo"/>
      </div>
      <div data-slot={NAVBAR_SLOTS.mobile_mid}/>
      <div className={styles.menu} data-slot={NAVBAR_SLOTS.mobile_right}>
        {show_top_menu && <div className={styles.top_menu}>
          {!is_client ? null
            : has_user ? <Dashboard_btn pos="top" to={cp_link}/>
            : <Login_menu on_login={on_login} pos="top"/>
          }
          {burger_pos=='right' && <Burger on_toggle={on_toggle}
            pos={burger_pos}/>}
        </div>}
        <div className={styles.menu_content}>
          <div className={styles.links}>
            <Links_group title="Products"
              content={()=><Products_menu variant="info"/>}/>
            <Links_group title="Documentation" to="/docs"/>
            <Links_group title="Locations"
              content={on_click=><Locations_menu on_toggle={on_click}/>}/>
            <Links_group title="Pricing"
              content={()=><Products_menu variant="pricing"/>}/>
          </div>
          {user ? <div className={styles.dashboard_container}>
            <Dashboard_btn pos="bottom" to={cp_link}/>
          </div> : <div className={styles.login_container}>
            <Login_menu on_login={on_login}
              pos="bottom"/>
          </div>}
        </div>
      </div>
    </>;
};

export const Mobile_nav = (props: t_mobile_nav_props)=>{
    const {opened} = props;
    const {theme} = use_theme({def: 'oculus'});
    const nav_cls = cn(styles.mobile_nav, theme.root, {
        [styles.opened]: opened,
    });
    // XXX dmitriiz: use logo_global_class only for temporary reason,
    // such as experiments
    return <div className={nav_cls}>
      <div className={cn(styles.container)}>
        <Oculus_mobile_nav {...props}/>
      </div>
    </div>;
};
